// src/pages/RegionalPackagesPage.js
import React, { useState, useEffect, useCallback } from 'react';
// DEĞİŞİKLİK: Yeni CSS modülünü import et
import styles from './RegionalPackagesPage.module.css';
import apiClient from '../services/ApiClient';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { toast } from 'react-toastify';

// DEĞİŞİKLİK: Sabitler güncellendi (Bölge ID'leri ve isimleri)
const REGIONS = [
    { id: 1, name: 'Avrupa' },
    { id: 2, name: 'Asya' },
    { id: 3, name: 'Kuzey Amerika' },
    { id: 4, name: 'Latin Amerika' },
    { id: 5, name: 'Afrika' },
    { id: 7, name: 'Pasifik' },
    { id: 6, name: 'Orta Doğu' },
    // Burayı kendi bölgesel ID ve isimlerinize göre doldurun
];
// Vergi dahil fiyatları güvenli şekilde formatlar (string veya number gelebilir)
const formatMoney = (value) => {
    const n = parseFloat(value);
    return isNaN(n) ? '—' : n.toFixed(2);
};
// DEĞİŞİKLİK: Component adı güncellendi
const RegionalPackagesPage = () => {
    // DEĞİŞİKLİK: State adı daha anlamlı hale getirildi
    const [selectedRegionId, setSelectedRegionId] = useState(REGIONS[0].id);
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editingStates, setEditingStates] = useState({});
    const [savingStates, setSavingStates] = useState({}); // { refillId1: true, refillId2: false }

    // DEĞİŞİKLİK: Fonksiyon adı ve API endpoint'i güncellendi
    const fetchPackagesForRegion = useCallback(async (regionId) => {
        if (!regionId) return;
        setIsLoading(true);
        setError(null);
        setProducts([]);

        try {
            // DEĞİŞİKLİK: API endpoint'i güncellendi
            const response = await apiClient.get(`/regions-data/${regionId}`);

            let fetchedProducts = [];
            // API yanıt işleme mantığı aynı
            if (response.data && Array.isArray(response.data.data)) {
                fetchedProducts = response.data.data[0]?.products || [];
            } else {
                console.warn("API'den beklenen formatta veri gelmedi:", response.data);
            }

            setProducts(fetchedProducts);

            const initialEdits = {};
            fetchedProducts.forEach(product => {
                product.refills.forEach(refill => {
                    const uniqueId = String(refill.id);
                    initialEdits[uniqueId] = {
                        basePriceTry: refill.basePriceTry,
                        isOpenGp: refill.isOpenGp,
                        isOpenAp: refill.isOpenAp,
                        isOpenWeb: refill.isOpenWeb
                    };
                });
            });
            setEditingStates(initialEdits);

        } catch (err) {
            console.error(`Bölge ${regionId} için paketler çekilirken hata:`, err);
            setError(`Paketler yüklenirken bir hata oluştu: ${err.response?.data?.message || err.message}`);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchPackagesForRegion(selectedRegionId);
    }, [selectedRegionId, fetchPackagesForRegion]);


    const handleInputChange = (refillId, field, value) => {
        setEditingStates(prev => ({ ...prev, [refillId]: { ...prev[refillId], [field]: value } }));
    };

    const handleCheckboxChange = (refillId, field, checked) => {
        setEditingStates(prev => ({ ...prev, [refillId]: { ...prev[refillId], [field]: checked } }));
    };

    const handleSaveChanges = async (productId, refillId, productName, refillTitle) => {
        const editedState = editingStates[refillId];
        if (!editedState) {
            console.error("Düzenleme durumu bulunamadı:", refillId);
            return;
        }

        const priceValueTL = parseFloat(editedState.basePriceTry);
        if (isNaN(priceValueTL) || priceValueTL < 0) {
            toast.error("Lütfen geçerli bir fiyat girin.");
            return;
        }

        setSavingStates(prev => ({ ...prev, [refillId]: true }));
        setError(null);

        const requestBody = {
            priceTL: priceValueTL,
            isOpenGp: editedState.isOpenGp,
            isOpenAp: editedState.isOpenAp,
            isOpenWeb: editedState.isOpenWeb,
            refillName: `${productName} - ${refillTitle}`, // Yeni parametre request body'ye eklendi

        };

        const originalProduct = products.find(p => p.originalId === productId);
        const originalRefill = originalProduct?.refills.find(r => String(r.id) === refillId);
        if (!originalRefill) return;

        // Optimistic UI
        setProducts(prevProducts =>
            prevProducts.map(product => {
                if (product.originalId === productId) {
                    return {
                        ...product,
                        refills: product.refills.map(refill =>
                            String(refill.id) === refillId ? { ...refill, ...editedState } : refill
                        )
                    };
                }
                return product;
            })
        );

        try {
            await apiClient.patch(`/esim-packages/refills/${refillId}`, requestBody); // ÖRNEK ENDPOINT

            toast.success(`Bölgesel Paket (ID: ${refillId}) başarıyla güncellendi.`);

        } catch (err) {
            console.error(`Bölgesel Refill ID ${refillId} güncellenirken API hatası:`, err);
            setError(`Paket güncellenirken bir hata oluştu: ${err.response?.data?.message || err.message}`);

            // Hata durumunda state'i geri al
            setProducts(prevProducts =>
                prevProducts.map(product => {
                    if (product.originalId === productId) {
                        return {
                            ...product,
                            refills: product.refills.map(refill =>
                                String(refill.id) === refillId ? originalRefill : refill
                            )
                        };
                    }
                    return product;
                })
            );
        } finally {
            setSavingStates(prev => ({ ...prev, [refillId]: false }));
        }
    };


    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.headerText}>
                    <h1 className={styles.title}>Bölgesel eSIM Paketleri</h1>
                    <p className={styles.subtitle}>Bölge bazlı paketlerin fiyatlarını ve mağaza durumlarını yönetin.</p>
                </div>
                <div className={styles.infoNotes}>
                    <div className={styles.infoNote}>
                        <span className={styles.infoIcon}>ℹ️</span>
                        <span className={styles.infoText}>Girilen fiyatlar vergi hariçtir.</span>
                    </div>
                </div>
            </div>

            <div className={styles.continentSelector}>
                {REGIONS.map(region => (
                    <button
                        key={region.id}
                        className={`${styles.continentButton} ${selectedRegionId === region.id ? styles.activeContinent : ''}`}
                        onClick={() => setSelectedRegionId(region.id)}
                        disabled={isLoading}
                    >
                        {region.name}
                    </button>
                ))}
            </div>

            <div className={styles.contentArea}>
                {isLoading ? (
                    <div className={styles.loadingContainer}><LoadingSpinner /></div>
                ) : error ? (
                    <div className={styles.errorPanel}>
                        <span className={styles.errorIcon}>⚠️</span>
                        <p className={styles.errorMessage}>Veriler alınamadı. Bağlantıyı kontrol edip tekrar deneyin.</p>
                        <button className={`${styles.retryButton} ghost`} onClick={() => fetchPackagesForRegion(selectedRegionId)}>Tekrar dene</button>
                    </div>
                ) : products.length === 0 ? (
                    <p className={styles.emptyState}>Bu bölge için gösterilecek ürün bulunamadı.</p>
                ) : (
                    products.map(product => (
                        <div key={product.originalId} className={styles.productCard}>
                            <div className={styles.productHeader}>
                                <img src={product.img} alt={product.name} className={styles.productImage} />
                                <div className={styles.productInfo}>
                                    <h2 className={styles.productName}>{product.name}</h2>
                                    <p className={styles.productDescription}>{product.description}</p>
                                </div>
                            </div>
                            <div className={styles.tableWrap}>
                            <table className={styles.refillsTable}>
                                <thead>
                                    <tr>
                                        <th>Paket (Refill)</th>
                                        <th className={styles.numCol}>Fiyat (TL)</th>
                                        <th className={styles.toggleCol}>Google Play</th>
                                        <th className={styles.toggleCol}>App Store</th>
                                        <th className={styles.toggleCol}>Web</th>
                                        <th className={styles.actionCol}>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {product.refills.map(refill => {
                                        const uniqueId = String(refill.id);
                                        const currentEditState = editingStates[uniqueId] || {};
                                        const isSavingThisRow = savingStates[uniqueId] || false;

                                        return (
                                            <tr key={uniqueId}>
                                                <td className="num">{refill.title} ({refill.amountMb / 1024} GB)</td>
                                                <td className={styles.numCol}>
                                                    <input
                                                        type="number"
                                                        value={currentEditState.basePriceTry || ''}
                                                        onChange={(e) => handleInputChange(uniqueId, 'basePriceTry', e.target.value)}
                                                        className={styles.priceInput}
                                                        step="0.01"
                                                        disabled={isSavingThisRow}
                                                    />
                                                    <div className={styles.taxPrices} title="Vergi dahil satış fiyatları">
                                                        <span className={styles.taxLabel}>Vergi dahil</span>
                                                        <span className={`${styles.taxVals} num`}>₺{formatMoney(refill.priceTL)} · €{formatMoney(refill.priceEuro)} · ${formatMoney(refill.priceUsd)}</span>
                                                    </div>
                                                </td>
                                                <td className={styles.toggleCell}>
                                                    <label className={styles.switch}>
                                                        <input
                                                            type="checkbox"
                                                            checked={currentEditState.isOpenGp || false}
                                                            onChange={(e) => handleCheckboxChange(uniqueId, 'isOpenGp', e.target.checked)}
                                                            disabled={isSavingThisRow}
                                                        />
                                                        <span className={`${styles.slider} ${styles.round}`}></span>
                                                    </label>
                                                </td>
                                                <td className={styles.toggleCell}>
                                                    <label className={styles.switch}>
                                                        <input
                                                            type="checkbox"
                                                            checked={currentEditState.isOpenAp || false}
                                                            onChange={(e) => handleCheckboxChange(uniqueId, 'isOpenAp', e.target.checked)}
                                                            disabled={isSavingThisRow}
                                                        />
                                                        <span className={`${styles.slider} ${styles.round}`}></span>
                                                    </label>
                                                </td>
                                                <td className={styles.toggleCell}>
                                                    <label className={styles.switch}>
                                                        <input
                                                            type="checkbox"
                                                            checked={currentEditState.isOpenWeb || false}
                                                            onChange={(e) => handleCheckboxChange(uniqueId, 'isOpenWeb', e.target.checked)}
                                                            disabled={isSavingThisRow}
                                                        />
                                                        <span className={`${styles.slider} ${styles.round}`}></span>
                                                    </label>
                                                </td>
                                                <td className={styles.actionCol}>
                                                    <button
                                                        onClick={() => handleSaveChanges(product.originalId, uniqueId, product.name, refill.title)}
                                                        className={styles.saveButton}
                                                        disabled={isSavingThisRow}
                                                    >
                                                        {isSavingThisRow ? 'Kaydediliyor...' : 'Kaydet'}
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};


export default RegionalPackagesPage;